import * as Yup from "yup";

import { TextManager } from "Components/TextContext/TextManager";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { CitizenshipFormValues } from "./interfaces";

export type ICitizenshipValidationObject = {
  isScandinavianCitizen: Yup.MixedSchema<BooleanFormType>;
  isStayingInNorwayForMoreThanFiveYears: Yup.MixedSchema<
    BooleanFormType | undefined
  >;
};

export const citizenshipValidationObject = (
  strict: boolean,
): ICitizenshipValidationObject => {
  const { getText } = TextManager;

  return {
    isScandinavianCitizen: Yup.mixed<BooleanFormType>().required(
      getText("customerform.validation.isscandinaviancitizen"),
    ),
    isStayingInNorwayForMoreThanFiveYears: Yup.mixed<BooleanFormType>().when(
      "isScandinavianCitizen",
      {
        is: BooleanFormType.FALSE,
        then: (schema) =>
          schema
            .required(
              getText(
                "customerform.validation.isstayinginnorwayformorethanfiveyears",
              ),
            )
            .when([], {
              is: () => strict,
              then: (schema) => schema.oneOf([BooleanFormType.TRUE], ""),
            }),
      },
    ),
  };
};

export const citizenshipValidationSchema = (
  strict = true,
): Yup.ObjectSchema<CitizenshipFormValues> => {
  return Yup.object(citizenshipValidationObject(strict)).defined();
};
